module.exports = __webpack_public_path__ + "img/ctrl-p-stub--.5bf95493.svg";